module.exports = __webpack_public_path__ + "img/D30.8b366350.png";